import React, { createContext, useContext, useState } from "react";

// Upload Context 創建
const ProjectContext = createContext();

// 提供者組件
export const ProjectProvider = ({ children }) => {
  const [projectData, setProjectData] = useState([]);


  const [projectStatus, setProjectStatus] = useState(""); // 用於管理上傳狀態

  // 提供更新函數，支持局部更新
  const updateProjectData = (fieldOrData, value) => {
    if (typeof fieldOrData === "object") {
      // 更新整個對象
      setProjectData((prev) => ({
        ...prev,
        ...fieldOrData,
      }));
    } else {
      // 單個欄位更新
      setProjectData((prev) => ({
        ...prev,
        [fieldOrData]: value,
      }));
    }
    // console.log(projectData);
  };

  return (
    <ProjectContext.Provider value={{
      projectData,
      updateProjectData,
      projectStatus, // 確保上傳狀態被傳入
      setProjectStatus, // 確保更新狀態的函數被傳入
    }}>
      {children}
    </ProjectContext.Provider>
  );
};

// 自定義 Hook
export const useProjectContext = () => useContext(ProjectContext);
